class FiltroMulta{
  constructor(
  {
    placa = null,
    renavam = null,
    numero_ait = null,
    numero_processamento = null,
    numero_notificacao = null,
    codigo_lancamento = null,
    cpf_cnpj_proprietario = null,
    data_infracao_inicio = null,
    data_infracao_fim = null,
    componente = null,
  } = {}
  ) {
    this.placa = placa;
    this.renavam = renavam;
    this.numero_ait = numero_ait;
    this.numero_processamento = numero_processamento;
    this.numero_notificacao = numero_notificacao;
    this.codigo_lancamento = codigo_lancamento;
    this.cpf_cnpj_proprietario = cpf_cnpj_proprietario;
    this.data_infracao_inicio = data_infracao_inicio;
    this.data_infracao_fim = data_infracao_fim;
    this.componente = componente;
  }
}

export default FiltroMulta;